import { render, staticRenderFns } from "./safeFly.vue?vue&type=template&id=085d1704&scoped=true&"
import script from "./safeFly.vue?vue&type=script&lang=js&"
export * from "./safeFly.vue?vue&type=script&lang=js&"
import style0 from "./safeFly.vue?vue&type=style&index=0&id=085d1704&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085d1704",
  null
  
)

export default component.exports